import { render, staticRenderFns } from "./seek.vue?vue&type=template&id=bfae456c&scoped=true"
import script from "./seek.vue?vue&type=script&lang=js"
export * from "./seek.vue?vue&type=script&lang=js"
import style0 from "./seek.vue?vue&type=style&index=0&id=bfae456c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfae456c",
  null
  
)

export default component.exports